import { Box } from "@stenajs-webui/core";
import {
  TextInputButton,
  type TextInputButtonSize,
} from "@stenajs-webui/elements";
import type { FC } from "react";

import type { ImportExportStatusCode } from "../../../gql/graphql";
import { resolveIconProps } from "../util/ImportExportStatusUtil";

interface Props {
  code: ImportExportStatusCode;
  onClick: () => void;
  size: TextInputButtonSize;
  spin?: boolean;
  title?: string;
}

export const ImportExportStatusIcon: FC<Props> = ({
  code,
  onClick,
  title,
  size,
  spin,
  ...props
}) => {
  const { icon, variant, className } = resolveIconProps(code);

  if (!icon) {
    return <TextInputButtonPlaceholder size={size} />;
  }

  return (
    <TextInputButton
      onClick={onClick}
      title={title}
      spin={spin}
      size={size}
      icon={icon}
      variant={variant}
      className={className}
      {...props}
    />
  );
};

export function getIconButtonSize(size: TextInputButtonSize) {
  return size === "medium" ? "3rem" : "1.8rem";
}

export const TextInputButtonPlaceholder = ({ size }: Pick<Props, "size">) => {
  const iconSize = getIconButtonSize(size);

  return <Box height={iconSize} width={iconSize} />;
};
